import { useMutation, useQueryClient } from '@tanstack/react-query'
import { PromoCodeFormValues } from 'Modules'

import { AppAdmin } from 'api/app-admin'
import { mapFormToPromoCodePayload } from 'modules/promo-code/api-adapters'
import { logError } from 'utils/logger'

import { promoCodeKeys } from './query-keys'

const invalidateLists = (queryClient: ReturnType<typeof useQueryClient>) =>
  queryClient.invalidateQueries({ queryKey: promoCodeKeys.lists() })

export const useCreatePromoCode = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (values: PromoCodeFormValues) => {
      const res = await AppAdmin.createPromoCode(mapFormToPromoCodePayload(values))
      return res.data?.data
    },
    onSuccess: () => {
      invalidateLists(queryClient)
    },
    onError: (err) => logError('Create promo code failed', err),
  })
}

export const useUpdatePromoCode = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({ id, values }: { id: string; values: PromoCodeFormValues }) => {
      const res = await AppAdmin.updatePromoCode(id, mapFormToPromoCodePayload(values))
      return res.data?.data
    },
    onSuccess: (_data, vars) => {
      invalidateLists(queryClient)
      queryClient.invalidateQueries({ queryKey: promoCodeKeys.detail(vars.id) })
    },
    onError: (err) => logError('Update promo code failed', err),
  })
}

export const useDeletePromoCode = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (id: string) => {
      await AppAdmin.deletePromoCode(id)
      return id
    },
    onSuccess: () => {
      invalidateLists(queryClient)
    },
    onError: (err) => logError('Delete promo code failed', err),
  })
}
